import RestClient from '../../../../api/axiosInterceptor';
import { pharmacyVerificationActions, pharmacyResendVerificationActions } from '../../../actions/user/pharmacy/Account/verification';
import { toast } from 'react-toastify';

/**
 * Helper function to create asynchronous actions for Redux.
 * @param {string} actionType - The action type to dispatch.
 * @param {function} apiCall - The API call function to make the request.
 */
const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
  try {
    dispatch({ type: actionType.REQUEST });
    console.log('Sending request to Resend Email Verification...');

    const response = await apiCall();

    dispatch({
      type: actionType.SUCCESS,
      payload: response.data
    });
    toast.success(response.data.message, { position: 'top-center' });
  } catch (error) {
    console.log('Resend Verification Error:', error);
    const errorMessage = error.response?.data?.error;

    dispatch({
      type: actionType.FAILURE,
      error: errorMessage
    });
    toast.error(errorMessage, { position: 'top-center' });
  }
};

export const pharmacyVerifyEmail = (token) =>
  createAsyncAction(
    pharmacyVerificationActions.EMAIL,
    () => RestClient.post('/pharmacy/verify-email/', { token })
  );

export const pharmacyResendVerificationEmail = (uid) =>
  createAsyncAction(
    pharmacyResendVerificationActions.RESEND_VERIFICATION_EMAIL,
    () => RestClient.get(`/pharmacy/resend-verification-email/${uid}/`)
  );

/**
 * Request OTP for phone verification.
 * @param {string} phone_number - The user's phone number.
 */
export const requestPhoneOTP = (phone_number) =>
  createAsyncAction(
    pharmacyVerificationActions.PHONE,
    () => RestClient.post('/pharmacy/verify-phone/', { phone_number })
  );

/**
 * Verify OTP for phone number.
 * @param {string} phone_number - The user's phone number.
 * @param {string} otp - The OTP entered by the user.
 */
export const verifyPhoneOTP = (phone_number, otp) =>
  createAsyncAction(
    pharmacyVerificationActions.PHONE,
    () => RestClient.post('/pharmacy/verify-phone/', { phone_number, otp })
  );
